import styled from "styled-components";


export const Container = styled.section`
  margin-top: 12rem;

  .case-layout{
    display: grid;
    grid-template-columns: 30rem minmax(0, 1fr);
    gap: 6rem;
    max-width: 110rem;
    margin: 0 auto;
  }

  .case-aside{
    position: sticky;
    top: 12rem;
    align-self: start;
  }

  .eyebrow{
    font-family: 'Red Hat Mono', monospace;
    font-size: 1.3rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: var(--accent-text);
    margin-bottom: 1.6rem;
  }

  h2{
    font-size: 3rem;
    line-height: 1.15;
    letter-spacing: -0.01em;
    margin-bottom: 3.2rem;
  }

  /* Same visual language as the About skills block */
  .case-fact{
    padding: 1.4rem 0;
    border-top: 1px solid rgba(128, 128, 128, 0.3);

    dt{
      font-family: 'Red Hat Mono', monospace;
      font-size: 1.3rem;
      color: var(--accent-text);
      text-transform: uppercase;
      letter-spacing: 0.1em;
      margin-bottom: 0.4rem;
    }

    dd{
      font-size: 1.5rem;
      line-height: 1.6;
      opacity: 0.85;
    }
  }

  .case-block{
    margin-top: 5.6rem;

    h3{
      font-size: 2.4rem;
      margin-bottom: 1.6rem;
    }

    p{
      font-size: 1.7rem;
      line-height: 1.7;
      max-width: 68ch;
      opacity: 0.9;
    }

    p + p{
      margin-top: 1.6rem;
    }

    code{
      font-family: 'Red Hat Mono', monospace;
      font-size: 0.92em;
    }
  }

  /* The first block lines up with the top of the aside */
  .case-article > div:first-child .case-block{
    margin-top: 0;
  }

  .decision{
    padding: 2.4rem 0;
    border-top: 1px solid rgba(128, 128, 128, 0.3);

    &:last-child{
      padding-bottom: 0;
    }

    h4{
      font-size: 1.9rem;
      font-weight: 700;
      line-height: 1.3;
      margin-bottom: 0.8rem;
    }
  }

  .case-actions{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1.6rem 2.4rem;
    margin-top: 5.6rem;
  }

  /* Same pill as the project cards, but on the page background: colors inherit for both themes */
  .pill-link{
    display: inline-block;
    font-family: 'Red Hat Mono', monospace;
    font-size: 1.3rem;
    padding: 0.7rem 1.4rem;
    border: 1px solid rgba(128, 128, 128, 0.6);
    border-radius: 10rem;
    color: inherit;
    transition: border-color 0.25s, color 0.25s;

    &:hover,
    &:focus-visible{
      border-color: var(--accent-text);
      color: var(--accent-text);
    }
  }

  .back-link{
    font-family: 'Red Hat Mono', monospace;
    font-size: 1.4rem;
    color: var(--accent-text);

    &:hover{
      text-decoration: underline;
      text-underline-offset: 0.4rem;
    }
  }

  .pill-link:focus-visible,
  .back-link:focus-visible{
    outline: 2px solid var(--accent-text);
    outline-offset: 3px;
  }

  @media (max-width: 960px){
    .case-layout{
      grid-template-columns: minmax(0, 1fr);
      gap: 4.8rem;
    }

    .case-aside{
      position: static;
    }

    h2{
      font-size: 2.6rem;
    }
  }
`
